import * as Yup from 'yup';
import { DictionaryNaceCz } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryNaceCz>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
